import { z } from "zod";

const idOpt = z.preprocess((v) => {
  if (v === "" || v === undefined || v === null) {
    return null;
  }
  const n = Number(v);

  return Number.isFinite(n) ? n : null;
}, z.number().nullable());

/** RHF leaves many fields undefined until touched; Zod 4 is strict on undefined vs z.string(). */
function reqStr(minLen: number, max: number, minMsg: string) {
  return z.preprocess(
    (v) => (v === undefined || v === null ? "" : String(v)),
    z.string().min(minLen, minMsg).max(max),
  );
}

function optStr(max: number) {
  return z.preprocess(
    (v) => (v === undefined || v === null ? "" : String(v)),
    z.string().max(max),
  );
}

function numMin(min: number) {
  return z.preprocess((v) => {
    if (v === undefined || v === null || v === "") {
      return 0;
    }
    const n = typeof v === "number" ? v : Number(v);

    return Number.isFinite(n) ? n : 0;
  }, z.number().min(min));
}

function numMinMax(min: number, max: number) {
  return z.preprocess((v) => {
    if (v === undefined || v === null || v === "") {
      return 0;
    }
    const n = typeof v === "number" ? v : Number(v);

    return Number.isFinite(n) ? n : 0;
  }, z.number().min(min).max(max));
}

export const productFormSchema = z.object({
  name: reqStr(1, 255, "Name required"),
  brand: optStr(120),
  sku: optStr(120),
  barcode: optStr(120),
  category_id: idOpt.optional(),
  unit_id: idOpt.optional(),
  hsn_code: optStr(32),
  gst_rate: numMinMax(0, 100),
  cost_price: numMin(0),
  selling_price: numMin(0),
  mrp: numMin(0),
  stock_qty: numMin(0),
  branch_id: idOpt.optional(),
  is_active: z.preprocess(
    (v) => (v === undefined || v === null ? true : Boolean(v)),
    z.boolean(),
  ),
});

export type ProductFormValues = z.infer<typeof productFormSchema>;
